export default "__VITE_ASSET__bgU71Vgr__"